module.exports = __webpack_public_path__ + "img/enveloppe_plane.svg";